<template>
    <div class="basic_wrap">
        <div class="m-flex red-top-nav">
            <div class="back_left" @click="$router.back()"></div>
            <div class="big_tit">{{ $t('hetong') }}</div>
        </div>
        <div class="contract-wrap m-pd1">
            <div class="m-flex m-f-center">
                <p class="h4">Financial product investment agreement</p>
            </div>
            <p class="h3">Financial management is not a deposit, and the products are risky, so investment must be done
                with caution.</p>
            <p>Party A (Investor ) and Party B ( Tesla Argentina Headquarters ) have reached the following agreement
                through consultation :</p>
            <p class="h3">1. Important tips</p>
            <p>1. This agreement, together with the "Financial Management Product Instructions", "Risk Disclosure
                Statement", "Financial Management Product Agency Sales Agreement ", and "Information on Investors'
                Rights and Interests" constitute a complete and indivisible financial product sales document and have
                the same legal effect. If this agreement is inconsistent with the "Financial Management Product
                Instructions", the "Financial Management Product Instructions" shall prevail. </p>
            <p>2. This financial product does not guarantee principal and income. Affected by various market fluctuation
                factors, this financial product may
                There may be but are not limited to credit risk, market risk, liquidity risk, policy risk and other risk
                factors, which shall be disclosed by Party B in the "Financial Management Product Instructions" and
                "Risk Disclosure Statement". Party A should carefully read and fully understand the detailed terms and
                possible risks of the "Financial Management Product Instructions" and "Risk Disclosure Statement"
                corresponding to the financial products.
            </p>
            <p>3. Party A’s signing of this agreement (including electronic channel confirmation) is deemed to have read
                this agreement and the complete financial product sales documents in detail, fully understood the terms
                and potential risks of the document, voluntarily purchased this financial product, and agreed to abide
                by the financial product . Agreements in the sales documents.</p>
            <p class="h3">2. Rights and obligations of both parties</p>
            <p class="h3">(1) Rights and obligations of Party A</p>
            <p>1.legal person with full capacity for civil conduct and accepts and signs the " Financial Management
                Product Investment Agreement" , "Financial Management Product Instructions", "Risk Disclosure
                Statement", and "Financial Management Product Agency Sales Agreement " , "Information on Investors'
                Rights and Interests" and other sales documents, and there is no doubt or objection to the relevant
                terms; Party A has clearly understood and agreed that the investment management and other activities of
                financial products under the financial product sales documents will be implemented by Party B, and is
                fully aware of the potential risks of the products Be willing and able to take risks as they arise. The
                market analysis and forecasts provided by Party B to Party A are for reference only. Any decisions made
                by Party A based on them are based on Party A's own judgment , and Party B does not assume any
                responsibility.</p>
            <p>2. Party A agrees that Party B shall act in accordance with relevant laws and regulations , "Financial
                Management Product Instructions" , "Risk Disclosure Statement",
                the "Financial Management Product Agency Sales Agreement" and "Investors' Rights and Interests" sales
                document or product investment management require the selection or entrustment of relevant financial
                investment cooperation institutions and custody institutions; agree that Party B signs the agreement in
                its own name or the name of the financial product, etc. Relevant legal documents; commitment to bear the
                legal consequences arising from Party B's performance of the agreement and other relevant legal
                documents .
            </p>
            <p>3. Party A agrees that Party B shall base its investment decision-making process on the matters
                stipulated in this Agreement and the "Financial Management Product Instructions", "Risk Disclosure
                Statement", "Financial Management Product Agency Sales Agreement", "Investors' Rights and Interests" and
                other sales documents. and risk management mechanisms to make and implement relevant investment
                management decisions.</p>
            <p>4.Party A authorizes Party B to provide relevant information of Party A to the registration department or
                regulatory department for financial product registration and other needs in accordance with regulatory
                requirements.</p>
            <p class="h3">(2) Party B’s rights and obligations</p>
            <p>1.shall implement investment management in good faith, prudently and diligently in accordance with the
                laws and regulations, this agreement and the "Financial Management Product Instructions", "Risk
                Disclosure Statement", "Financial Management Product Agency Sales Agreement", "Investors' Rights and
                Interests" and other sales documents. conduct, manage the assets of financial products with professional
                skills, and protect the interests of all investors in financial products in accordance with the law.</p>
            <p>2.Party B does not promise or guarantee the income of any financial product, nor will it promise or
                guarantee the minimum income or the safety of principal.</p>
            <p>3.the product type , investment scope, investment asset types and proportions stated in the "Financial
                Management Product Instructions" , "Risk Disclosure Statement" and other sales documents, and ensures
                that the financial products fluctuate reasonably according to the agreed ratio during the duration of
                the financial product. If there are major changes in the market that cause the investment ratio of
                financial products to temporarily exceed the floating range and may have a significant impact on Party
                A's financial income, Party B will promptly disclose information to investors through the agreed
                information disclosure channels .</p>
            <p>4.In order to achieve the investment goals of financial products and safeguard the interests of all
                investors in financial products, Party B has the right to exercise investment-related rights and perform
                relevant obligations. Party B will adjust the investment plan in accordance with relevant laws and
                regulations in line with the principle of safeguarding the interests of all investors in financial
                products. If Party A does not accept it, it can redeem the financial products held in advance as agreed.
                For financial products that cannot be redeemed in advance, Party A agrees that Party B will take
                reasonable measures to redeem them on the date when Party B notifies them that they can be redeemed.</p>
            <p>5.When the asset security of a financial management product is infringed, Party B has the right to take
                litigation or other rights relief measures in its own name on behalf of all investors of the financial
                product. The expenses and legal consequences arising from Party B's taking the above actions shall be
                borne by all investors of the financial product, and shall have the right to directly deduct them from
                the property of the financial product.</p>
            <p>6.changes in laws and regulations, adjustments to financial policies, the introduction of emergency
                measures, changes in market conditions, abnormal risk events, etc. occur , Party B may make decisions to
                adjust the investment plans agreed in the "Financial Product Instructions" and "Risk Disclosure
                Statement" as necessary . Including but not limited to investment scope, investment types, investment
                proportions, investment methods, etc., and timely notification through agreed information disclosure
                channels. If the proportion agreed in the sales document of the financial product is exceeded , except
                for high-risk financial products that exceed the proportion and invest in lower-risk assets, the written
                consent of the investor must first be obtained and the financial product information must be registered
                in the national banking financial information registration system. .</p>
            <p>7.Party B is unable or delayed in performing this Agreement due to unforeseen, unavoidable,
                insurmountable force majeure events such as changes in laws, regulations and regulatory policies,
                natural disasters, wars, or unexpected events such as system failures, communication failures,
                suspension of trading in the investment market, etc. Party B does not assume any liability, but shall
                notify Party A in an appropriate manner and take all necessary remedial measures to reduce relevant
                losses.</p>
            <p>8.When an external event or objective situation occurs that is not led by Party B and can only be
                passively accepted and may have a significant impact on the investment management of financial products
                or asset security, Party B will promptly notify the Party B through the agreed information disclosure
                channels </p>
            <p>9.Party B shall bear the obligation to keep confidential Party A’s information learned during the sales
                process of financial products, unless otherwise provided by laws, regulations and regulatory provisions
                or otherwise agreed by both parties.</p>
            <p class="h3">3.Effectiveness and invalidation of the agreement</p>
            <p class="h3">1.Offline signing method.</p>
            <p>This Agreement shall be constituted between Party A and Party B from the date when Party A signs or seals
                the agreement (if Party A is a natural person, it shall sign ; if Party A is an institution, it shall be
                signed by the legal representative or authorized agent and stamped with the official seal) A binding
                legal document.</p>
            <p class="h3">2.Electronic channel signing method.</p>
            <p>For financial transactions through electronic channels, Party A clicks "confirm and agree to relevant
                content" or "confirm" or "accept" or "read and agree" or "agree" or other words of equivalent meaning on
                the corresponding electronic page. has signed, indicating that it agrees to accept this Agreement, and
                the corresponding
                "Financial Management Product Instructions" , "Risk Disclosure Statement", "Financial Management Product
                Agency Sales Agreement", "Investor Rights Instructions" and other relevant sales documents, and
                recognize their legal binding force.
            </p>
            <p class="h">3.This agreement will be automatically</p>
            <p>terminated if the customer fails to purchase financial products, Party B terminates it early, and the
                financial products expire and are settled . Unless Party A and Party B agree, the revised terms will not
                take effect on transactions that have been completed before the modification takes effect.</p>
            <p class="h3">4. Resolution of disputes</p>
            <p>All disputes arising from the performance of this Agreement or activities related to this Agreement
                between Party A and Party B shall first be resolved through friendly negotiation based on the principle
                of good faith; if the dispute cannot be resolved through negotiation, it shall be settled by litigation
                in the People's Court where Party B is located.</p>
            <div class="md1">
                <p>Organization: Tesla Argentina Headquarters</p>
                <p>Purchaser's signature: {{ info.mobile }}</p>
                <p>Signing date: {{ time }} </p>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from "vue";
import {
    Empty
} from "vant";

import Fetch from "../../utils/fetch";
Vue.use(Empty);

export default {
    name: "order",
    data() {
        return {
            lang: this.$i18n.locale || "zh_cn",
            info: {}
        };
    },
    created() {
        this.getUserInfo()
    },
    mounted() {
    },
    computed: {
        time() {
            const time = this.$route.query.time
            let date = new Date(time * 1),
                year = date.getFullYear(),
                month = date.getMonth() + 1,
                strDate = date.getDate()
            if (month < 10) month = `0${month}`
            if (strDate < 10) strDate = `0${strDate}`
            return `${year}-${month}-${strDate}`
        }
    },
    methods: {
        getUserInfo() {
            Fetch('/user/info').then((r) => {
                this.info = r.data;
            })
        }
    }
}
</script>

<style lang="less" scoped>
.contract-wrap {

    &>p,
    &>div {
        margin: .5em 0;
    }

    p {
        font-size: 14px;
        text-indent: 2em;

        &.h3 {
            font-size: 16px;
            text-indent: 0;
        }

        &.h4 {
            font-size: 18px;
            text-indent: 0;

        }
    }
}
</style>
